// extracted by mini-css-extract-plugin
module.exports = {"link":"admin_link__1kKEX","ButtonsList":"admin_ButtonsList__1qTPz","mainDiv":"admin_mainDiv__DGoJz"};